<template>
  <div id="editor1">
    <ckeditor :editor="editor" :config="editorConfig" v-model="editorData" @input="onInputOption" @ready="onReadyOption"
      @blur="handleBlur" :disabled="propDataEditorDisabled"></ckeditor>
  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';

import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
// import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import Link from '@ckeditor/ckeditor5-link/src/link';
import List from '@ckeditor/ckeditor5-list/src/list';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight';
import FileRpository from "@ckeditor/ckeditor5-upload/src/filerepository";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";
import TextTransformation from "@ckeditor/ckeditor5-typing/src/texttransformation";
import BlockToolbar from "@ckeditor/ckeditor5-ui/src/toolbar/block/blocktoolbar";
import HeadingButtonsUI from "@ckeditor/ckeditor5-heading/src/headingbuttonsui";
import ParagraphButtonUI from "@ckeditor/ckeditor5-paragraph/src/paragraphbuttonui";

import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';

class UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  async upload() {
    return new Promise((resolve, reject) => {
      const reader = this.reader = new window.FileReader();

      reader.addEventListener('load', () => {
        resolve({ default: reader.result });
      });

      reader.addEventListener('error', err => {
        reject(err);
      });

      reader.addEventListener('abort', () => {
        reject();
      });

      this.loader.file.then(file => {
        reader.readAsDataURL(file);
      });
    });
  }

  abort() {
    this.reader.abort();
  }
}

export default {
  name: "cknoimg-component",
  props: {
    value: String,
    propDataEditorDisabled: Boolean,
  },
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component

  },
  data() {
    return {
      editor: ClassicEditor,
      editorData: "",
      editorTempData: "",
      editorConfig: {
        plugins:
          [
            FileRpository,
            Essentials,
            Autoformat,
            Alignment,
            Bold,
            Italic,
            Link,
            BlockQuote,
            Heading,
            Indent,
            Paragraph,
            PasteFromOffice,
            Table,
            TableToolbar,
            List,
            Highlight,
            Underline,
            Image,
            ImageStyle,
            ImageToolbar,
            ImageUpload,
            ImageResize,
            TextTransformation,
            ParagraphButtonUI,
            HeadingButtonsUI,
            BlockToolbar
          ],
        removeButtons: "",
        toolbar: {
          items:
            [
              'heading',
              '|',
              'bold',
              'italic',
              'underline', // added underline plugin
              '|',
              'bulletedList',
              'numberedList',
              'alignment',
              '|',
              'indent',
              'outdent',
              'highlight',
              '|',
              'link',
              'blockQuote',
              "imageUpload",
              'insertTable',
              'mergeTableCells',
              '|',
              'undo',
              'redo',
            ],
        },
        // image: {
        //   toolbar: [
        //     "imageStyle:full",
        //     "imageStyle:side",
        //     "|",
        //     "imageTextAlternative"
        //   ]
        // },
        image: {
          // Configure the available styles.
          styles: [
            'alignLeft', 'alignCenter', 'alignRight'
          ],

          // Configure the available image resize options.
          resizeOptions: [
            {
              name: 'resizeImage:original',
              label: 'Original',
              value: null
            },
            {
              name: 'resizeImage:50',
              label: '50%',
              value: '50'
            },
            {
              name: 'resizeImage:75',
              label: '75%',
              value: '75'
            }
          ],

          // You need to configure the image toolbar, too, so it shows the new style
          // buttons as well as the resize buttons.
          toolbar: [
            'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
            '|',
            'resizeImage',
            '|',
            'imageTextAlternative'
          ]
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
        },
        cloudServices: {},
        mediaEmbed: {},
        extraPlugins: [this.uploader]
      },
      model: null,
      editorReady: false
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          if (this.editorReady) {
            this.editorData = val;
          } else {
            this.editorTempData = val;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    fn_init() { },
    onInputOption: function (event) {
      this.editorData = event;
      this.$emit('input', this.editorData);
    },

    onReadyOption: function (editor) {
      this.editorReady = true;
      this.editorData = this.editorTempData;
      this.editorData = this.value;
    },
    uploader(editor) {
      if (editor.plugins.has('FileRepository')) {
        editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
          return new UploadAdapter(loader);
        }
      }
    },

    handleBlur(event) {
      this.$emit('blur', event);
    },
  },
  created: function () { },
  mounted: function () {
    this.fn_init();
  }
};
</script>
<style scoped>

</style>
